import React, { useEffect, useState } from "react";
import {
  CogIcon,
  UserIcon,
  BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link, useNavigate } from "react-router-dom";
import Stepper from "../Common/Stepper";
import { useDispatch, useSelector } from "react-redux";
import {
  DetailsApi,
  updateTrustNumberCall,
  verifyCIN_Api_Call,
} from "../../services/redux/ApiActions";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import showNotification from "../../services/redux/NotifcationService";
import LogoDiv from "../Common/LogoDiv";
import logo from "../../img/BBPS_Horizontal.png";

export default function StepThreeCin() {
  const [cin, setCIN] = useState("");
  const details = useSelector((state) => state.details.details);
  const customerData = useSelector((state) => state.customerData.customerData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const containsLiability = details?.result.businessType
    .toLowerCase()
    .includes("liability");
  const containsPrivate = details?.result.businessType
    .toLowerCase()
    .includes("private");
  const containsPublic = details?.result.businessType
    .toLowerCase()
    .includes("public");
  const containsSociety = details?.result.businessType
    .toLowerCase()
    .includes("society");
  const containsLimited = details?.result.businessType
    .toLowerCase()
    .includes("limited");
  const containsPartnerShip = details?.result.businessType
    .toLowerCase()
    .includes("partnership");
  const [showLogo, setShowLogo] = useState(false);

  // const handleCIN = (e) => {
  //     setCIN(e.target.value)
  // }
  const handleCIN = (e) => {
    const value = e.target.value.toUpperCase();

    // Allow only alphanumeric characters and max 24 length
    if (/^[A-Z0-9]*$/.test(value) && value.length <= 24) {
      setCIN(value);
    }
  };

  useEffect(() => {
    getDetails();
    const responseData = details?.result.cinByCompanyResponse;
    const response = JSON.parse(responseData);
    const companiesList = response?.data?.result?.companiesList;

    if (companiesList && companiesList.length === 1) {
      setCIN(companiesList[0].companyID);
    }
  }, []);

  const SkipStep = async () => {
    if (containsPrivate || containsPublic || containsLiability) {
      navigate("/Customer/Step3CinDirectorList");
    } else {
      navigate("/Customer/Step3Partner");
    }
  };
  const handleSubmit = async () => {
    if (cin === "") {
      showNotification(
        `${
          containsSociety
            ? "Trust Number"
            : containsLiability && containsLimited && containsPartnerShip
            ? "LLP"
            : "CIN"
        } is required`,
        "error"
      );
    } else {
      // setDetails(data)
      if (containsPrivate || containsPublic || containsLiability) {
        const payload = {
          cin: cin.toString(),
          customerId: customerData?.custId,
          createdIp: "",
          createdUserAgent: "",
        };
        const data = await dispatch(
          verifyCIN_Api_Call(
            payload,
            customerData?.token_chr,
            customerData?.custId
          )
        );
        if (data.statusCode === 200) {
          showNotification("Success", "success");
          getDetails();
          navigate("/Customer/Step3CinDirectorList");
        }
      } else {
        const payload = {
          customerId: customerData?.custId,
          trustNumber: cin,
        };
        try {
          const data = await dispatch(
            updateTrustNumberCall(
              payload,
              customerData?.token_chr,
              customerData?.custId
            )
          );
          if (data.statusCode === 200) {
            navigate("/Customer/Step3Partner");
            getDetails();
          }
        } catch (error) {
          showNotification(error, "error");
        }
      }
    }
  };

  const getDetails = async () => {
    // console.log(userAgent)
    const Payload = {
      id: customerData?.custId,
    };
    // console.log(Payload)
    const data = await dispatch(
      DetailsApi(Payload, customerData?.token_chr, "customer")
    );
    dispatch(setDetailsData(data));
    if (data?.result.cin !== null) {
      setCIN(details?.result.cin);
    }
    if (data?.result?.programId === 34 || data?.result?.programId === 35) {
      setShowLogo(false);
    } else {
      setShowLogo(true);
    }
  };

  return (
    <>
      <body className="mailsentbody">
        <LogoDiv className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <Stepper />
                <div className="bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          Company Identification Number
                        </h1>
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                      {showLogo &&
                        {
                          /* <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "-5px",
                          }}
                        >
                          <img src={logo} width={"100px"} height={"100px"} />
                        </div> */
                        }}
                    </div>
                  </div>
                  <div className="py-2 text-center">
                    <h1 className="text-sm text-gray-600">
                      {containsSociety
                        ? "Please Enter Your Trust Number"
                        : containsLiability &&
                          containsLimited &&
                          containsPartnerShip
                        ? "Please Enter Your LLP"
                        : "Please enter your CIN"}
                    </h1>
                  </div>
                  <div className=" border-none border-collapse rounded-md">
                    <div className="py-4">
                      <label
                        for="email"
                        className="block text-md font-medium leading-6 text-gray-900"
                      >
                        {containsSociety
                          ? "Trust Number"
                          : containsLiability &&
                            containsLimited &&
                            containsPartnerShip
                          ? "LLP"
                          : "CIN"}{" "}
                        <span className="text-red-600">*</span>
                      </label>
                      <CustomerInput
                        value={cin}
                        onChange={handleCIN}
                        inputStyles={{ padding: "12px" }}
                      />
                    </div>

                    <div className="col-span-12 md:col-span-7 lg:col-span-7">
                      <div className="relative text-center">
                        <button
                          onClick={handleSubmit}
                          className="vtpRm-action-button"
                        >
                          {details?.result.lastCompletedStep > 3
                            ? "Proceed"
                            : "Proceed"}
                        </button>
                        {details?.result.lastCompletedStep > 3 ? (
                          <>
                            <span
                              className="skip-btn hover:cursor-pointer py-4 px-4"
                              onClick={SkipStep}
                            >
                              Skip this step
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
            </div>
          </div>
        </LogoDiv>
      </body>
    </>
  );
}
